import {createApp} from "vue";
import LatestJobsContactLocations from "./components/LatestJobsContactLocations.vue";

createApp({})
    .component("LatestJobsContactLocations", LatestJobsContactLocations)
    .mount(".app-widgets-duo-location");
